import { useIntl } from 'react-intl';
import { ButtonUI, Checkbox } from 'sonata-react-components';

import './selectionToolbar.scss';

export type SelectionToolbarProps = {
  resultsCount: number;
  selectedCount: number;
  hasSelection: boolean;
  allSelected: boolean;
  onClear: () => void;
  onSelectAll: () => void;
  /** Hides the "Select all / Unselect all" control. Defaults to true. */
  showSelectAll?: boolean;
  /** Hides the "Clear selection" control. Defaults to true. */
  showClear?: boolean;
};

export default function SelectionToolbar({
  resultsCount,
  selectedCount,
  hasSelection,
  allSelected,
  onClear,
  onSelectAll,
  showSelectAll = true,
  showClear = true
}: Readonly<SelectionToolbarProps>) {
  const { formatMessage } = useIntl();

  return (
    <div className="selectionToolbar">
      <div className="taptapListToolbarSummary">
        <span className="taptapListToolbar__summaryLabel" style={{ marginRight: 'var(--spacing-4)' }}>
          {formatMessage({ defaultMessage: 'Results:', id: 'common.results' })}
        </span>
        <span className="taptapListToolbar__summaryValue">{resultsCount}</span>
        <span className="taptapListToolbar__summaryLabel" style={{ marginRight: 'var(--spacing-4)' }}>
          {formatMessage({ defaultMessage: 'Selected:', id: 'common.selected' })}
        </span>
        <span className="taptapListToolbar__summaryValue">{selectedCount}</span>
      </div>
      {showSelectAll && (
        <Checkbox
          active={allSelected}
          id="selection-toolbar-select-all"
          labelText={
            allSelected
              ? formatMessage({ defaultMessage: 'Unselect all', id: 'common.unselectAll' })
              : formatMessage({ defaultMessage: 'Select all', id: 'common.selectAll' })
          }
          onClickAction={onSelectAll}
          tiny
          type="checkbox"
        />
      )}
      {showClear && (
        <ButtonUI
          disabled={!hasSelection}
          icon="fa-regular fa-trash"
          id="selection-toolbar-clear-selection"
          onClick={onClear}
          shape="link"
          size="ultraSmall"
          text={formatMessage({
            defaultMessage: 'Clear selection',
            id: 'driveToStore.selectionToolbar.clearSelection'
          })}
        />
      )}
    </div>
  );
}
